import axios from "axios";

const endpoint = `${process.env.REACT_APP_API_URL}/smq/Outil`;

export const OUTIL_ERROR_MESSAGES = {
  fetch: "Une erreur s’est produite lors de la récupération des données.",
  save: "Une erreur s’est produite lors de l’enregistrement des données.",
  download: "Une erreur s’est produite lors du téléchargement du fichier.",
};

const responsePayload = (response) => {
  const payload = response?.data;
  if (payload?.status === false) {
    throw new Error(payload.message || "Une erreur est survenue");
  }
  return payload;
};

const logTechnicalError = (error) => {
  if (process.env.NODE_ENV === "development") {
    // Les détails techniques restent limités à la console de développement.
    console.error("[OutilService]", error);
  }
};

const request = async (operation, errorMessage) => {
  try {
    return responsePayload(await operation());
  } catch (error) {
    logTechnicalError(error);
    throw new Error(errorMessage);
  }
};

const OutilService = {
  getEntree(processusId) {
    return request(
      () => axios.get(`${endpoint}/entree/${processusId}`),
      OUTIL_ERROR_MESSAGES.fetch
    );
  },

  createEntree(formData) {
    return request(
      () => axios.post(`${endpoint}/entree`, formData),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  updateEntree(outilEntreeId, formData) {
    return request(
      () => axios.post(`${endpoint}/entree_update/${outilEntreeId}`, formData),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  getContextes(processusId) {
    return request(
      () => axios.get(`${endpoint}/contextes/${processusId}`),
      OUTIL_ERROR_MESSAGES.fetch
    );
  },

  getContexte(contexteId) {
    return request(
      () => axios.get(`${endpoint}/contexte/${contexteId}`),
      OUTIL_ERROR_MESSAGES.fetch
    );
  },

  createContexte(formData) {
    return request(
      () => axios.post(`${endpoint}/contexte`, formData),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  updateContexte(contexteId, formData) {
    return request(
      () => axios.post(`${endpoint}/contexte_update/${contexteId}`, formData),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  validateContexte(contexteId) {
    return request(
      () => axios.put(`${endpoint}/contexte_validate/${contexteId}`),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  deleteContexte(contexteId) {
    return request(
      () => axios.delete(`${endpoint}/contexte/${contexteId}`),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  downloadContexteFile(contexteId) {
    return this.downloadBlob(`${endpoint}/contexte_file/${contexteId}`);
  },

  getParties(processusId) {
    return request(
      () => axios.get(`${endpoint}/parties/${processusId}`),
      OUTIL_ERROR_MESSAGES.fetch
    );
  },

  getPartie(partieInteresseeId) {
    return request(
      () => axios.get(`${endpoint}/partie/${partieInteresseeId}`),
      OUTIL_ERROR_MESSAGES.fetch
    );
  },

  createPartie(formData) {
    return request(
      () => axios.post(`${endpoint}/partie`, formData),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  updatePartie(partieInteresseeId, formData) {
    return request(
      () => axios.post(`${endpoint}/partie_update/${partieInteresseeId}`, formData),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  validatePartie(partieInteresseeId) {
    return request(
      () => axios.put(`${endpoint}/partie_validate/${partieInteresseeId}`),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  deletePartie(partieInteresseeId) {
    return request(
      () => axios.delete(`${endpoint}/partie/${partieInteresseeId}`),
      OUTIL_ERROR_MESSAGES.save
    );
  },

  downloadPartieFile(partieInteresseeId) {
    return this.downloadBlob(
      `${endpoint}/partie_file/${partieInteresseeId}`
    );
  },

  getFicheProcessus(processusId) {
    return request(
      () => axios.get(`${endpoint}/fiche_processus/${processusId}`),
      OUTIL_ERROR_MESSAGES.fetch
    );
  },

  saveFicheProcessus(processusId, payload) {
    return request(
      () => axios.put(`${endpoint}/fiche_processus/${processusId}`, payload),
      OUTIL_ERROR_MESSAGES.save
    );
  },
  async downloadFile(outilEntreeId) {
    return this.downloadBlob(`${endpoint}/file/${outilEntreeId}`);
  },

  async downloadBlob(url) {
    try {
      return await axios.get(url, {
        responseType: "blob",
      });
    } catch (error) {
      logTechnicalError(error);
      throw new Error(OUTIL_ERROR_MESSAGES.download);
    }
  },
};

export default OutilService;
